import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * FileManagerApi - axios parameter creator
 * @export
 */
const FileManagerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory: async (FileToken, name, options = {}) => {
            const localVarPath = `/v1/FileManager/CreateDirectory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem: async (FileToken, options = {}) => {
            const localVarPath = `/v1/FileManager/DeleteItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {Array<FileToken>} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadItems: async (FileToken, options = {}) => {
            const localVarPath = `/v1/FileManager/DownloadItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItems: async (FileToken, options = {}) => {
            const localVarPath = `/v1/FileManager/GetItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveItem: async (FileToken, key, options = {}) => {
            const localVarPath = `/v1/FileManager/MoveItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [newName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameItem: async (FileToken, newName, options = {}) => {
            const localVarPath = `/v1/FileManager/RenameItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (newName !== undefined) {
                localVarQueryParameter['newName'] = newName;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FileToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadItems: async (key, options = {}) => {
            const localVarPath = `/v1/FileManager/UploadItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FileManagerApi - functional programming interface
 * @export
 */
const FileManagerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FileManagerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDirectory(FileToken, name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDirectory(FileToken, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.createDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItem(FileToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItem(FileToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.deleteItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {Array<FileToken>} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadItems(FileToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadItems(FileToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.downloadItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItems(FileToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItems(FileToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.getItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveItem(FileToken, key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveItem(FileToken, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.moveItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [newName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameItem(FileToken, newName, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameItem(FileToken, newName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.renameItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadItems(key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadItems(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileManagerApi.uploadItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FileManagerApi - factory interface
 * @export
 */
const FileManagerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FileManagerApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory(FileToken, name, options) {
            return localVarFp.createDirectory(FileToken, name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem(FileToken, options) {
            return localVarFp.deleteItem(FileToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {Array<FileToken>} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadItems(FileToken, options) {
            return localVarFp.downloadItems(FileToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItems(FileToken, options) {
            return localVarFp.getItems(FileToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveItem(FileToken, key, options) {
            return localVarFp.moveItem(FileToken, key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FileToken} [FileToken]
         * @param {string} [newName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameItem(FileToken, newName, options) {
            return localVarFp.renameItem(FileToken, newName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadItems(key, options) {
            return localVarFp.uploadItems(key, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FileManagerApi - object-oriented interface
 * @export
 * @class FileManagerApi
 * @extends {BaseAPI}
 */
class FileManagerApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FileToken} [FileToken]
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    createDirectory(FileToken, name, options) {
        return FileManagerApiFp(this.configuration).createDirectory(FileToken, name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FileToken} [FileToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    deleteItem(FileToken, options) {
        return FileManagerApiFp(this.configuration).deleteItem(FileToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {Array<FileToken>} [FileToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    downloadItems(FileToken, options) {
        return FileManagerApiFp(this.configuration).downloadItems(FileToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FileToken} [FileToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    getItems(FileToken, options) {
        return FileManagerApiFp(this.configuration).getItems(FileToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FileToken} [FileToken]
     * @param {string} [key]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    moveItem(FileToken, key, options) {
        return FileManagerApiFp(this.configuration).moveItem(FileToken, key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FileToken} [FileToken]
     * @param {string} [newName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    renameItem(FileToken, newName, options) {
        return FileManagerApiFp(this.configuration).renameItem(FileToken, newName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {string} [key]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileManagerApi
     */
    uploadItems(key, options) {
        return FileManagerApiFp(this.configuration).uploadItems(key, options).then((request) => request(this.axios, this.basePath));
    }
}

export { FileManagerApi, FileManagerApiAxiosParamCreator, FileManagerApiFactory, FileManagerApiFp };
//# sourceMappingURL=file-manager-api.js.map
